/* sugar:assets/progress-tabs.js@2.2.5 */
(() => {
  if (customElements.get('progress-tabs')) return;
  // Tabs over stages; the chart shows each stage's points and every earlier stage's
  class ProgressTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-pt-tab]')];
      this.stages = [...this.querySelectorAll('[data-pt-stage]')];
      this.marks = [...this.querySelectorAll('[data-pt-chart] [data-s]')];
      this.show(1, false);
      this.onClick = event => {
        const tab = event.target.closest('[data-pt-tab]');
        if (tab && this.contains(tab)) this.show(Number(tab.dataset.ptTab), false);
      };
      this.onKey = event => {
        const i = this.tabs.indexOf(document.activeElement);
        if (i < 0 || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const n = this.tabs.length;
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? n - 1 : (i + (event.key === 'ArrowRight' ? 1 : n - 1)) % n;
        this.show(next + 1, true);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.onSelect = event => {
        const stage = event.target.closest('[data-pt-stage]');
        if (stage) this.show(Number(stage.dataset.ptStage), false);
      };
      if (window.Shopify?.designMode) this.addEventListener('shopify:block:select', this.onSelect);
    }
    show(index, focus) {
      this.tabs.forEach((tab, i) => {
        const on = i + 1 === index;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });
      this.stages.forEach((stage, i) => { stage.hidden = i + 1 !== index; });
      this.marks.forEach(mark => mark.classList.toggle('is-off', Number(mark.dataset.s) > index));
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.removeEventListener('shopify:block:select', this.onSelect);
    }
  }
  customElements.define('progress-tabs', ProgressTabs);
})();
